
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Maintenance de site Internet : c’est inclus chez ALEO !",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "À quoi sert la maintenance d’un site Web ? Qui s’en occupe ? Quel coût engendre-t-elle ? Autant de questions auxquelles cet article répond.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Maintenance de site Internet : c’est inclus chez ALEO !",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "À quoi sert la maintenance d’un site Web ? Qui s’en occupe ? Quel coût engendre-t-elle ? Autant de questions auxquelles cet article répond.",
        },
      ],
    };
  },
};
